// extracted by mini-css-extract-plugin
module.exports = {"deliberationsContainer":"deliberations-module--deliberations-container--31c5n"};